(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('ConsoleWebService', ConsoleWebService);

    ConsoleWebService.$inject = ['$http', 'RequestService', 'ModalConstructor', 'AlertModalService'];

    function ConsoleWebService($http, RequestService, ModalConstructor, AlertModalService) {

        return {
            sendCommand: sendCommand,
            disconnect: disconnect,
            consoleWebModalConstructor: consoleWebModalConstructor,
            errorModalConstructor: errorModalConstructor
        };

        function sendCommand(oltId, command) {
            return $http
                    .post(apiUrl(oltId + '/sendcmd'), command, requestConfig())
                    .then(responseData);
        }

        function disconnect(oltId) {
            return $http.post(apiUrl(oltId + '/disconnect'), null, {ignoreLoadingBar: true}).then(responseData);
        }

        // Modal Methods
        function consoleWebModalConstructor(oltId) {
            var consoleWeb = {
                templateUrl: 'app/components/console-web/console-web.html',
                controller: 'ConsoleWebController',
                controllerAs: 'vmConsoleWeb',
                size: 'lg',
                backdrop: 'static',
                windowClass: 'modal-console',
                resolve: {oltId: oltId}
            };
            ModalConstructor.open(consoleWeb);
        }

        function errorModalConstructor(response, action) {
            AlertModalService.error(response, action, 'console');
        }

        // Helper functions
        function apiUrl(method) {
            return RequestService.apiUrl('olts/console', method);
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        function requestConfig() {
            return {
                headers: {
                    'Content-Type': 'text/plain; charset=UTF-8',
                    'Accept': 'text/plain,application/json; charset=UTF-8'
                },
                cancelable: true,
                ignoreLoadingBar: true
            };
        }

    }
})();